window.theme.block('hero-video-content', el => {
    const videoPlayer = el.querySelector('.video-player');
    const hero = el;

    // Return early if no element is present in the page
    if (!videoPlayer) return;

    // Configurable threshold (e.g., 25% from the top of the screen)
    const triggerThreshold = 0.25; // Adjust this value to change the threshold

    // Listen for scroll events
    let ticking = false;

    function handleScroll() {
        const scrollTop = window.scrollY;
        const heroTop = hero.getBoundingClientRect().top;
        const heroHeight = hero.offsetHeight;
        const triggerPoint = window.innerHeight * triggerThreshold;

        // Only scale if the hero is within the trigger threshold
        if (heroTop <= triggerPoint) {
            // Calculate zoom scale
            const scale = 1 + ((triggerPoint - heroTop) / heroHeight) * 0.5;

            // Apply the calculated styles
            videoPlayer.style.transform = `scale(${Math.max(scale, 1)})`; // Ensure the scale is at least 1
        }

        ticking = false;
    }

    document.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(handleScroll);
            ticking = true;
        }
    });

    // Title animation
    const animatedTitle = el.querySelector('.js-animated');

    if (animatedTitle) {
        let current = 1;
        const max = 6;
        const interval = 250;

        setInterval(() => {
            // remove current banner class
            animatedTitle.classList.remove(`banner-${current}`);

            // increment or loop back
            current = current < max ? current + 1 : 1;

            // add new banner class
            animatedTitle.classList.add(`banner-${current}`);
        }, interval);
    }

});
